/** Get survey list */
export const GET_SURVEYS_LIST_REQUEST = 'GET_SURVEYS_LIST_REQUEST';
export const GET_SURVEYS_LIST_SUCCESS = 'GET_SURVEYS_LIST_SUCCESS';
export const GET_SURVEYS_ERROR = 'GET_SURVEYS_ERROR';

/** Dashboard */
export const GET_DASHBOARD_CARD_REQUEST = 'GET_DASHBOARD_CARD_REQUEST';
export const GET_DASHBOARD_CARD_SUCCESS = 'GET_DASHBOARD_CARD_SUCCESS';
export const GET_DASHBOARD_CARD_ERROR = 'GET_DASHBOARD_CARD_ERROR';

export const GET_DASHBOARD_CHART_REQUEST = 'GET_DASHBOARD_CHART_REQUEST';
export const GET_DASHBOARD_CHART_SUCCESS = 'GET_DASHBOARD_CHART_SUCCESS';
export const GET_DASHBOARD_CHART_ERROR = 'GET_DASHBOARD_CHART_ERROR';

/** Reports */
export const GET_GLOBAL_REPORT_REQUEST = 'GET_GLOBAL_REPORT_REQUEST';
export const GET_GLOBAL_REPORT_SUCCESS = 'GET_GLOBAL_REPORT_SUCCESS';
export const SHOW_MODAL_GLOBAL = 'SHOW_MODAL_GLOBAL';
export const HIDE_MODAL_GLOBAL = 'HIDE_MODAL_GLOBAL';
export const SHOW_MODAL_INDIVIDUAL = 'SHOW_MODAL_INDIVIDUAL';
export const HIDE_MODAL_INDIVIDUAL = 'HIDE_MODAL_INDIVIDUAL'; 